import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { useDocsStore } from '../../store/docsStore';
import { useConfigStore } from '../../store/configStore';
import { OfflineIndicator } from '../Common/OfflineIndicator';
import styles from './Header.module.css';

export const Header: React.FC = () => {
  const { config } = useConfigStore();
  const { isAuthenticated, user, logout } = useAuthStore();
  const isOnline = useDocsStore((state) => state.isOnline);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const showResetPassword = !isAuthenticated && config.passwordResetEnabled;

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <Link to="/" className={styles.logo}>
          {config.appTitle}
        </Link>
        <nav className={styles.nav}>
          {isAuthenticated && (
            <>
              {isOnline && (
                <Link to="/new" className={styles.navLink}>
                  New Doc
                </Link>
              )}
              <Link to="/markdown-cheatsheet" className={styles.navLink}>
                Markdown Cheatsheet
              </Link>
              <Link to="/admin/users" className={styles.navLink}>
                Admin
              </Link>
            </>
          )}
          {showResetPassword && (
            <Link to="/reset-password" className={styles.navLink}>
              Reset Password
            </Link>
          )}
        </nav>
      </div>
      <div className={styles.headerRight}>
        <OfflineIndicator />
        {isAuthenticated ? (
          <>
            <span className={styles.userInfo}>{user?.username}</span>
            <button onClick={handleLogout} className={`${styles.btn} ${styles.btnSecondary}`}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login">
              <button className={`${styles.btn} ${styles.btnPrimary}`}>Login</button>
            </Link>
          </>
        )}
      </div>

      {/* Mobile - Offline indicator and menu button */}
      <div className={styles.mobileActions}>
        <OfflineIndicator />
        <button 
          className={styles.menuButton} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className={`${styles.hamburger} ${menuOpen ? styles.open : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <>
          <div className={styles.overlay} onClick={closeMenu}></div>
          <div className={styles.mobileMenu}>
            {isAuthenticated && (
              <>
                {isOnline && (
                  <Link to="/new" className={styles.mobileNavLink} onClick={closeMenu}>
                    New Doc
                  </Link>
                )}
                <Link to="/markdown-cheatsheet" className={styles.mobileNavLink} onClick={closeMenu}>
                  Markdown Cheatsheet
                </Link>
                <Link to="/admin/users" className={styles.mobileNavLink} onClick={closeMenu}>
                  Admin
                </Link>
                <div className={styles.mobileDivider}></div>
                <span className={styles.mobileUserInfo}>{user?.username}</span>
                <button onClick={handleLogout} className={`${styles.btn} ${styles.btnSecondary} ${styles.mobileBtn}`}>
                  Logout
                </button>
              </>
            )}
            {showResetPassword && (
              <>
                <Link to="/reset-password" className={styles.mobileNavLink} onClick={closeMenu}>
                  Reset Password
                </Link>
                <Link to="/login" onClick={closeMenu}>
                  <button className={`${styles.btn} ${styles.btnPrimary} ${styles.mobileBtn}`}>Login</button>
                </Link>
              </>
            )}
            {!showResetPassword && !isAuthenticated && (
              <Link to="/login" onClick={closeMenu}>
                <button className={`${styles.btn} ${styles.btnPrimary} ${styles.mobileBtn}`}>Login</button>
              </Link>
            )}
            {!isAuthenticated && (
              <Link to="/login" onClick={closeMenu}>
                <button className={`${styles.btn} ${styles.btnPrimary} ${styles.mobileBtn}`}>Login</button>
              </Link>
            )}
          </div>
        </>
      )}
    </header>
  );
};
